import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import extractTextService from "../../services/extractTextService";
import CenterModal from "../UI/Modal/CenterModal";
import { setDownloadImageFailed } from "../../reducers/extractText-reducer";

const DownloadImageFailedModal = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { downloadImageFailed } = useSelector((state) => state.extractText);
    const handleCloseModal = () => {
        dispatch(setDownloadImageFailed(false));
    };

    const cancelDownload = () => {
        extractTextService.cancelDownload();
    };

    const retryDownload = function () {
        extractTextService.retryDownload();
    };

    const modalHeader = (
        <>
            <h5 className='modal-title'>{localisedValues["download_failed"]}</h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={handleCloseModal}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );

    const modalBody = (
        <div className='cms-modal-text'>
            <p>{localisedValues["unable_download_image_tomarkup"]}</p>
        </div>
    );

    const modalFooter = (
        <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
            <div className='button'>
                <button className='btn default-btn-link' onClick={cancelDownload}>
                    {localisedValues["cancel_initcap"]}
                </button>
            </div>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={retryDownload}>
                    {localisedValues["try_again"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={downloadImageFailed}
            closeModal={handleCloseModal}
            modalClass='default-modal modal-small mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

export default DownloadImageFailedModal;
